module.exports = __webpack_public_path__ + "static/img/profile-today-user-pick-txt.84aa392.png";